import { Button, useDisclosure } from "@chakra-ui/react";
import { Download } from "../../../shared/icons";
import { useGoogleCalendarStatusQuery } from "../../perfil/hooks/useGoogleCalendarStatusQuery";
import ImportGoogleShiftsModal from "./ImportGoogleShiftsModal";

// Botão do cabeçalho do Calendário: só aparece para quem conectou o Google Agenda no
// perfil (a mesma consulta de status que a página de perfil usa).
export default function ImportFromGoogleButton({ year, month }) {
  const { data: status } = useGoogleCalendarStatusQuery();
  const disclosure = useDisclosure();
  if (!status?.connected) return null;

  return (
    <>
      <Button variant="outline" leftIcon={<Download size={16} />} onClick={disclosure.onOpen}>
        Importar do Google
      </Button>
      <ImportGoogleShiftsModal isOpen={disclosure.isOpen} onClose={disclosure.onClose} initialYear={year} initialMonth={month} />
    </>
  );
}
